(function () {
  'use strict';

  var checkoutSelector = '.zd-drawer-checkout';
  var checkoutUrl = '/checkout';

  function convertCheckoutButton(element) {
    if (!element || !element.matches || !element.matches(checkoutSelector)) return;

    if (element.tagName === 'A') {
      element.setAttribute('href', checkoutUrl);
      element.setAttribute('data-zd-direct-checkout', 'true');
      element.removeAttribute('disabled');
      element.removeAttribute('aria-disabled');
      return;
    }

    var link = document.createElement('a');
    var blockedAttributes = ['type', 'form', 'name', 'disabled', 'aria-disabled'];

    Array.prototype.forEach.call(element.attributes, function (attribute) {
      if (blockedAttributes.indexOf(attribute.name) === -1) {
        link.setAttribute(attribute.name, attribute.value);
      }
    });

    link.setAttribute('href', checkoutUrl);
    link.setAttribute('role', 'button');
    link.setAttribute('data-zd-direct-checkout', 'true');
    link.innerHTML = element.innerHTML;
    element.replaceWith(link);
  }

  function upgradeCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(checkoutSelector)) {
      convertCheckoutButton(scope);
    }

    Array.prototype.forEach.call(scope.querySelectorAll(checkoutSelector), convertCheckoutButton);
  }

  function initialise() {
    upgradeCheckoutButtons(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          convertCheckoutButton(mutation.target);
          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) upgradeCheckoutButtons(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest && event.target.closest(checkoutSelector);
    if (!checkout) return;

    event.preventDefault();
    window.location.assign(checkoutUrl);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener('pageshow', function () {
    upgradeCheckoutButtons(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    upgradeCheckoutButtons(event.target || document);
  });
})();

(function () {
  'use strict';

  var STYLE_ID = 'zenduce-mobile-header-upgrade';
  var MOBILE_MAX = 1024;

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '@media(max-width:' + MOBILE_MAX + 'px){' +
        '.zh-header .zh-main-row .zh-wrap{' +
          'display:grid!important;' +
          'grid-template-columns:auto auto minmax(0,1fr) auto!important;' +
          'align-items:center!important;' +
          'column-gap:14px!important;' +
        '}' +
        '.zh-header .zh-hamburger{order:1!important;justify-self:start!important;}' +
        '.zh-header .zh-mobile-search-toggle{' +
          'order:2!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
          'width:40px!important;height:40px!important;border:0!important;background:transparent!important;' +
          'padding:0!important;color:var(--zh-ink)!important;cursor:pointer!important;-webkit-tap-highlight-color:transparent!important;' +
        '}' +
        '.zh-header .zh-mobile-search-toggle svg{width:24px!important;height:24px!important;display:block!important;}' +
        '.zh-header .zh-logo{order:3!important;justify-self:center!important;min-width:0!important;}' +
        '.zh-header .zh-actions{order:4!important;justify-self:end!important;}' +
        '.zh-header .zh-mobile-search-row{' +
          'display:block!important;max-height:0!important;opacity:0!important;overflow:hidden!important;' +
          'transform:translateY(-8px)!important;border-bottom:0!important;' +
          'transition:max-height .28s ease,opacity .2s ease,transform .28s ease,border-color .2s ease!important;' +
        '}' +
        '.zh-header .zh-mobile-search-row.is-open{' +
          'max-height:98px!important;opacity:1!important;transform:translateY(0)!important;border-bottom:1px solid var(--zh-line)!important;' +
        '}' +
        '.zh-header .zh-mobile-search-row .zh-wrap{padding-top:10px!important;padding-bottom:12px!important;}' +
        '.zh-header .zh-mobile-search-row .zh-search-wide{display:flex!important;}' +
        '.zh-mobile-category-strip{display:block!important;background:var(--zh-paper)!important;border-bottom:1px solid var(--zh-line)!important;}' +
        '.zh-mobile-category-strip .zh-wrap{' +
          'display:flex!important;align-items:center!important;gap:10px!important;overflow-x:auto!important;' +
          'padding-top:10px!important;padding-bottom:12px!important;-webkit-overflow-scrolling:touch!important;scroll-snap-type:x mandatory!important;' +
          'scrollbar-width:none!important;' +
        '}' +
        '.zh-mobile-category-strip .zh-wrap::-webkit-scrollbar{display:none!important;}' +
        '.zh-mobile-category-chip{' +
          'flex:0 0 auto!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
          'min-height:44px!important;padding:0 22px!important;border:1px solid var(--zh-line)!important;border-radius:999px!important;' +
          'background:#f5efe7!important;color:var(--zh-ink)!important;text-decoration:none!important;' +
          'font-family:var(--zh-sans)!important;font-size:15px!important;font-weight:500!important;line-height:1!important;white-space:nowrap!important;' +
          'scroll-snap-align:start!important;' +
        '}' +
        '.zh-mobile-category-chip:active{transform:scale(.98)!important;}' +
      '}' +
      '@media(max-width:420px){' +
        '.zh-header .zh-main-row .zh-wrap{column-gap:10px!important;}' +
        '.zh-header .zh-mobile-search-toggle{width:36px!important;height:36px!important;}' +
        '.zh-header .zh-mobile-search-toggle svg{width:22px!important;height:22px!important;}' +
        '.zh-mobile-category-chip{min-height:42px!important;padding:0 20px!important;font-size:14px!important;}' +
      '}' +
      '@media(min-width:' + (MOBILE_MAX + 1) + 'px){' +
        '.zh-header .zh-mobile-search-toggle,.zh-mobile-category-strip{display:none!important;}' +
      '}';

    document.head.appendChild(style);
  }

  function searchIconSvg() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2"></circle><path d="M16.5 16.5 21 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  }

  function ensureSearchToggle() {
    var header = document.querySelector('.zh-header');
    var hamburger = header && header.querySelector('.zh-hamburger');
    var row = header && header.querySelector('.zh-mobile-search-row');
    if (!header || !hamburger || !row) return;

    var existing = header.querySelector('.zh-mobile-search-toggle');
    if (!existing) {
      existing = document.createElement('button');
      existing.type = 'button';
      existing.className = 'zh-mobile-search-toggle';
      existing.setAttribute('aria-label', 'Open search');
      existing.setAttribute('aria-expanded', 'false');
      existing.innerHTML = searchIconSvg();
      hamburger.insertAdjacentElement('afterend', existing);
    }

    if (existing.getAttribute('data-zenduce-search-toggle-ready') === 'true') return;
    existing.setAttribute('data-zenduce-search-toggle-ready', 'true');

    existing.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var isOpen = row.classList.toggle('is-open');
      existing.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      existing.setAttribute('aria-label', isOpen ? 'Close search' : 'Open search');

      if (isOpen) {
        window.setTimeout(function () {
          var searchButton = row.querySelector('.zh-search-wide');
          if (searchButton && typeof searchButton.focus === 'function') searchButton.focus({ preventScroll: true });
        }, 180);
      }
    });
  }

  function normalizedText(node) {
    return (node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function menuLinks() {
    var links = Array.prototype.slice.call(document.querySelectorAll('.zh-nav > a[href]'));
    var seen = {};
    var blocked = /^(home|account|wishlist|cart|search|help|contact)$/i;

    links = links.map(function (link) {
      return {
        title: normalizedText(link),
        href: link.getAttribute('href')
      };
    }).filter(function (item) {
      if (!item.title || !item.href || item.href === '#' || blocked.test(item.title)) return false;
      var key = item.title.toLowerCase() + '|' + item.href;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    if (links.length) return links.slice(0, 8);

    return [
      { title: 'Chandeliers', href: '/collections/chandeliers' },
      { title: 'Pendant Lights', href: '/collections/pendant-lights' },
      { title: 'Floor Lamps', href: '/collections/floor-lamps' },
      { title: 'Wall Lights', href: '/collections/wall-lights' },
      { title: 'Table Lamps', href: '/collections/table-lamps' }
    ];
  }

  function ensureCategoryStrip() {
    var header = document.querySelector('.zh-header');
    if (!header || header.querySelector('.zh-mobile-category-strip')) return;

    var anchor = header.querySelector('.zh-mobile-search-row') || header.querySelector('.zh-main-row');
    if (!anchor) return;

    var strip = document.createElement('nav');
    strip.className = 'zh-mobile-category-strip';
    strip.setAttribute('aria-label', 'Popular categories');

    var wrap = document.createElement('div');
    wrap.className = 'zh-wrap';
    strip.appendChild(wrap);

    menuLinks().forEach(function (item) {
      var chip = document.createElement('a');
      chip.className = 'zh-mobile-category-chip';
      chip.href = item.href;
      chip.textContent = item.title;
      wrap.appendChild(chip);
    });

    anchor.insertAdjacentElement('afterend', strip);
  }

  function initMobileHeaderUpgrade() {
    ensureStyle();
    ensureSearchToggle();
    ensureCategoryStrip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileHeaderUpgrade, { once: true });
  } else {
    initMobileHeaderUpgrade();
  }

  window.addEventListener('pageshow', initMobileHeaderUpgrade, { passive: true });
  document.addEventListener('shopify:section:load', initMobileHeaderUpgrade);
})();
